import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/lems-v1/images/file-type/folder.svg'
import _imports_1 from '@/assets/lems-v1/images/file-type/audio.svg'
import _imports_2 from '@/assets/lems-v1/images/file-type/image.svg'
import _imports_3 from '@/assets/lems-v1/images/file-type/pdf.svg'


const _hoisted_1 = { class: "files-list-section" }
const _hoisted_2 = { class: "files-list-hd" }
const _hoisted_3 = { class: "files-list-btm" }
const _hoisted_4 = { class: "files-list-row" }
const _hoisted_5 = { "data-title": "CHAT ROOM" }
const _hoisted_6 = {
  class: "link",
  id: "chatLink",
  href: "employee-chat.html"
}
const _hoisted_7 = { "data-title": "SIZE" }
const _hoisted_8 = { "data-title": "ACTION" }
const _hoisted_9 = { class: "action-dropdown" }
const _hoisted_10 = { class: "action-dropdownbox" }
const _hoisted_11 = { class: "action-dropdownbox-in" }
const _hoisted_12 = {
  class: "download-icon",
  id: "downloadLink",
  href: "javascript:void(0);",
  "data-bs-toggle": "modal",
  "data-bs-target": "#fileDownloadPop"
}
const _hoisted_13 = {
  class: "delete-icon",
  id: "deleteFileLink",
  href: "javascript:void(0);",
  "data-bs-toggle": "modal",
  "data-bs-target": "#deleteFile"
}
const _hoisted_14 = { class: "files-list-row" }
const _hoisted_15 = { "data-title": "CHAT ROOM" }
const _hoisted_16 = {
  class: "link",
  id: "chatLink",
  href: "employee-chat.html"
}
const _hoisted_17 = { "data-title": "SIZE" }
const _hoisted_18 = { "data-title": "ACTION" }
const _hoisted_19 = { class: "action-dropdown" }
const _hoisted_20 = { class: "action-dropdownbox" }
const _hoisted_21 = { class: "action-dropdownbox-in" }
const _hoisted_22 = {
  class: "download-icon",
  id: "downloadLink",
  href: "javascript:void(0);",
  "data-bs-toggle": "modal",
  "data-bs-target": "#fileDownloadPop"
}
const _hoisted_23 = {
  class: "delete-icon",
  id: "deleteFileLink",
  href: "javascript:void(0);",
  "data-bs-toggle": "modal",
  "data-bs-target": "#deleteFile"
}
const _hoisted_24 = { class: "files-list-row" }
const _hoisted_25 = { "data-title": "CHAT ROOM" }
const _hoisted_26 = {
  class: "link",
  id: "chatLink",
  href: "employee-chat.html"
}
const _hoisted_27 = { "data-title": "SIZE" }
const _hoisted_28 = { "data-title": "ACTION" }
const _hoisted_29 = { class: "action-dropdown" }
const _hoisted_30 = { class: "action-dropdownbox" }
const _hoisted_31 = { class: "action-dropdownbox-in" }
const _hoisted_32 = {
  class: "download-icon",
  id: "downloadLink",
  href: "javascript:void(0);",
  "data-bs-toggle": "modal",
  "data-bs-target": "#fileDownloadPop"
}
const _hoisted_33 = {
  class: "delete-icon",
  id: "deleteFileLink",
  href: "javascript:void(0);",
  "data-bs-toggle": "modal",
  "data-bs-target": "#deleteFile"
}
const _hoisted_34 = { class: "files-list-row" }
const _hoisted_35 = { "data-title": "CHAT ROOM" }
const _hoisted_36 = {
  class: "link",
  id: "chatLink",
  href: "employee-chat.html"
}
const _hoisted_37 = { "data-title": "SIZE" }
const _hoisted_38 = { "data-title": "ACTION" }
const _hoisted_39 = { class: "action-dropdown" }
const _hoisted_40 = { class: "action-dropdownbox" }
const _hoisted_41 = { class: "action-dropdownbox-in" }
const _hoisted_42 = {
  class: "download-icon",
  id: "downloadLink",
  href: "javascript:void(0);",
  "data-bs-toggle": "modal",
  "data-bs-target": "#fileDownloadPop"
}
const _hoisted_43 = {
  class: "delete-icon",
  id: "deleteFileLink",
  href: "javascript:void(0);",
  "data-bs-toggle": "modal",
  "data-bs-target": "#deleteFile"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.constants.RECENT_PROJECT_FILES_TEXT), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.constants.NAME_TEXT), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.constants.CHAT_ROOM_TEXT), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.constants.SHARED_BY_TEXT), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.constants.DATE_TEXT), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.constants.SIZE_TEXT), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.constants.ACTION_TEXT), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          _cache[1] || (_cache[1] = _createElementVNode("li", null, [
            _createElementVNode("div", { class: "files-d-b" }, [
              _createElementVNode("i", null, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                })
              ]),
              _createElementVNode("div", { class: "files-d-b-span" }, [
                _createElementVNode("strong", null, "Wellbux Client Folder"),
                _createElementVNode("p", null, "This file attached to Wellbux")
              ])
            ])
          ], -1)),
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.constants.CHAT_LINK_LINK), 1)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("li", { "data-title": "SHARED BY" }, "Ashok", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("li", { "data-title": "DATE" }, "Apr. 5, 2021, 8:15 am", -1)),
          _createElementVNode("li", _hoisted_7, " 293 " + _toDisplayString(_ctx.constants.MB_TEXT), 1),
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[0] || (_cache[0] = _createElementVNode("a", {
                href: "javascript:void(0);",
                class: "action-dots"
              }, [
                _createElementVNode("span")
              ], -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.constants.DOWNLOAD_LINK), 1),
                  _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.constants.DELETE_LINK), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("ul", null, [
          _cache[5] || (_cache[5] = _createElementVNode("li", null, [
            _createElementVNode("div", { class: "files-d-b" }, [
              _createElementVNode("i", null, [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: ""
                })
              ]),
              _createElementVNode("div", { class: "files-d-b-span" }, [
                _createElementVNode("strong", null, "Wellbux discuss with Binod.mp3"),
                _createElementVNode("p", null, "This file attached to Wellbux")
              ])
            ])
          ], -1)),
          _createElementVNode("li", _hoisted_15, [
            _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.constants.CHAT_LINK_LINK), 1)
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("li", { "data-title": "SHARED BY" }, "Binod", -1)),
          _cache[7] || (_cache[7] = _createElementVNode("li", { "data-title": "DATE" }, "Apr. 5, 2021, 8:15 am", -1)),
          _createElementVNode("li", _hoisted_17, " 400 " + _toDisplayString(_ctx.constants.MB_TEXT), 1),
          _createElementVNode("li", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _cache[4] || (_cache[4] = _createElementVNode("a", {
                href: "javascript:void(0);",
                class: "action-dots"
              }, [
                _createElementVNode("span")
              ], -1)),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("a", _hoisted_22, _toDisplayString(_ctx.constants.DOWNLOAD_LINK), 1),
                  _createElementVNode("a", _hoisted_23, _toDisplayString(_ctx.constants.DELETE_LINK), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("ul", null, [
          _cache[9] || (_cache[9] = _createElementVNode("li", null, [
            _createElementVNode("div", { class: "files-d-b" }, [
              _createElementVNode("i", null, [
                _createElementVNode("img", {
                  src: _imports_2,
                  alt: ""
                })
              ]),
              _createElementVNode("div", { class: "files-d-b-span" }, [
                _createElementVNode("strong", null, "Wellbux Logo.png"),
                _createElementVNode("p", null, "This file attached to Wellbux")
              ])
            ])
          ], -1)),
          _createElementVNode("li", _hoisted_25, [
            _createElementVNode("a", _hoisted_26, _toDisplayString(_ctx.constants.CHAT_LINK_LINK), 1)
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("li", { "data-title": "SHARED BY" }, "Ashok", -1)),
          _cache[11] || (_cache[11] = _createElementVNode("li", { "data-title": "DATE" }, "Apr. 5, 2021, 8:15 am", -1)),
          _createElementVNode("li", _hoisted_27, " 1 " + _toDisplayString(_ctx.constants.MB_TEXT), 1),
          _createElementVNode("li", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _cache[8] || (_cache[8] = _createElementVNode("a", {
                href: "javascript:void(0);",
                class: "action-dots"
              }, [
                _createElementVNode("span")
              ], -1)),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("a", _hoisted_32, _toDisplayString(_ctx.constants.DOWNLOAD_LINK), 1),
                  _createElementVNode("a", _hoisted_33, _toDisplayString(_ctx.constants.DELETE_LINK), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("ul", null, [
          _cache[13] || (_cache[13] = _createElementVNode("li", null, [
            _createElementVNode("div", { class: "files-d-b" }, [
              _createElementVNode("i", null, [
                _createElementVNode("img", {
                  src: _imports_3,
                  alt: ""
                })
              ]),
              _createElementVNode("div", { class: "files-d-b-span" }, [
                _createElementVNode("strong", null, "Wellbux-pics.pdf"),
                _createElementVNode("p", null, "This file attached to Wellbux")
              ])
            ])
          ], -1)),
          _createElementVNode("li", _hoisted_35, [
            _createElementVNode("a", _hoisted_36, _toDisplayString(_ctx.constants.CHAT_LINK_LINK), 1)
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("li", { "data-title": "SHARED BY" }, "Monika", -1)),
          _cache[15] || (_cache[15] = _createElementVNode("li", { "data-title": "DATE" }, "Apr. 5, 2021, 8:15 am", -1)),
          _createElementVNode("li", _hoisted_37, " 293 " + _toDisplayString(_ctx.constants.MB_TEXT), 1),
          _createElementVNode("li", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _cache[12] || (_cache[12] = _createElementVNode("a", {
                href: "javascript:void(0);",
                class: "action-dots"
              }, [
                _createElementVNode("span")
              ], -1)),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("a", _hoisted_42, _toDisplayString(_ctx.constants.DOWNLOAD_LINK), 1),
                  _createElementVNode("a", _hoisted_43, _toDisplayString(_ctx.constants.DELETE_LINK), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}